<div class="page" id="connector-def-page">

  <div class="action-bar dark-bg with-tabs">
    <div class="title">
      Conector: {connector && connector.uuid || '?'}
    </div>

    <div class="tabs">
      <span class="tabs-breadcrumbs">
        <span class="account-full-name">Cuenta</span> /
        <span class="profile-full-name">Persona</span> /
        Conector
      </span>
    </div>

    <div class="actions-set">
      <!-- svelte-ignore a11y-missing-content -->
      <a class="action-btn back" href="#back" title="Cancelar"></a>
      <!-- svelte-ignore a11y-missing-content -->
      <a class="action-btn done" href="#" title="Guardar y Salir" on:click={()=> saveIt('exit')}
        ></a>
      &nbsp;|&nbsp;
      <!-- svelte-ignore a11y-missing-content -->
      <a class="action-btn delete" href="#" title="Eliminar" on:click={()=> deleteIt('exit')}
        ></a>
      <a class="action-btn sos" href="#">SOS</a>
    </div>

  </div>

  <div class="content with-sidebar">

    <Panel flex items="start" justify="start" py="md">

      <SidebarPanel 
        on:selected={(ev) => selected = ev.detail.id}
        selected={selected} 
        items={[
          { id: 'form', title: 'Datos del conector', description: '' },        
          { id: 'database', title: 'Base de datos', description: '' },        
          { id: 'configs', title: 'Configuraciones' },        
          //{ id: 'log', title: 'Log de eventos', description: '' }        
        ]}
        />

      <Panel grow px="md" border-left="3">
        <Panel classes="container" mt=0 maxw="58rem">
          <div class="section" id="conector">

            {#if status}
              <Panel bg="light" py="nm" px="md" mb="sm" rounded="xs">
                <Text md>{messages[status]}</Text>
              </Panel>
            {/if}

            {#if selected === 'form'}
              <ConnectorForm data={connector}/>
            {/if}

            {#if selected === 'database'}
              <DbSettings bind:db={contents.settings.database} />
            {/if}  

            {#if selected === 'configs'}

              <Panel mb="nm">
                {#if currentAction === null}
                  <ActionsList 
                    on:selected={(ev) => selectedAction(ev.detail)}
                    on:delete={(ev) => deleteAction(ev)}
                    actions={allActions} 
                    />

                  <Button px="nm" py="sm" primary sm bold filled
                    on:click={addDownloadRecordAction}>
                    Agrega otra acción
                    </Button>
    
                  <Button px="nm" py="sm" primary sm bold filled
                    on:click={exportConfig}>
                    Exportar configuracion
                    </Button>
    
                  <Button px="nm" py="sm" primary sm bold filled
                    on:click={exportDbSchema}>
                    Exportar esquema para BD
                    </Button>
    
                {:else}
                  <ActionDownloadRecord 
                    on:closed={() => closedAction()}
                    on:changed={(ev) => updatedAction(ev)}
                    settings={contents.settings}
                    content={contents.record_downloads[currentAction]}
                    /> 
                {/if}
              </Panel>
            {/if}

            {#if selected === 'log'}
              Mostrariamos los logs aqui ...
            {/if}
          </div>
        </Panel>
   
      </Panel>
      
    </Panel>

  </div>

</div>

<script>
  import { onMount, tick } from 'svelte'
  import API from '@/api'
  import { route } from '@/pager'
  import { Connector } from '@/models'
  import { RecordDef, is } from '@/models'
  import { Account } from '@/models'
  import { restoreRecordDefs, recordDefsHash, recordDefsList } from '@/states/record-defs'
  import { cloned, slugify, createTextFileAndDownload } from '@/helpers'
  import { Panel, Heading, Label, Text, Button } from 'svelte-stylo'
  import SidebarPanel from '@/components/panels/SidebarPanel.svelte'
  import DbSettings from './DbSettings.svelte'
  import ConnectorForm from './ConnectorForm.svelte'
  import ActionsList from './ActionsList.svelte'
  import ActionDownloadRecord from './record-actions/ActionDownloadRecord.svelte';
  import { createAndAlterTablesDDL, createDatabaseDDL } from './record-actions/db-schema';
  import { buildConfigs } from './record-actions/config-download-records';


  const IS_SAVING = 1;
  const IS_DONE = 2;
  const IS_DELETING = 3;
  const HAS_ERRORS = 4;  

  const messages = [
    "",
    "Estamos guardando la info de este conector",
    "Listo !",
    "Estamos borrando este conector",
    "Hubo errores al guardarlo !",
  ]

  let
    page, 
    isCurrent = false,
    create = false,
    connector = Connector.empty(),
    status = null,
    selected = 'form',
    allActions = [],
    currentAction = null;

  let yes = false;

  let 
    account = Account.empty(),
    configured = Connector.getConfig(connector),
    contents = Connector.getContents(connector),
    settings = contents.settings;


  $: allActions = refreshAllActions(contents);


  onMount(async () => {
    // to make this Page visible to the router 
    page = route({page:"#connector-def-page", route: "#conector"}) ;
    console.log("DONE: installed ConnectorPage to route '#conector'");

    account = Account.get(); // get current account from cache/storage

    page.content = function(url, options) {
      console.log("ConnectorPage: page.content url=", url)
      isCurrent = false;

      // restore them because they may have changed between the time
      // when this page was mounted and when it is really used
      restoreRecordDefs();

      setTimeout(async () => {
        var id = Appl.URL.parameter(url, "id");
        connector = await API.connectors.get(id)
        configured = Connector.getConfig(connector);
        contents = Connector.getContents(connector);
        settings = contents.settings;
      }, 100);

      return this;
    }

    page.current = function() {
      this._current(); // call base method
      isCurrent = true;
      console.log("ConnectorDefPage: page.current")
      return this;
    };

    page.hidden = function() {
      isCurrent = false;
      console.log("ConnectorDefPage: page.hidden")
    }
  })


  function selectedAction(detail) {
    const aid = detail.id.toString();
    for (let j=0; j < contents.record_downloads.length; j++) {
      if (contents.record_downloads[j].id.toString() === aid) {
        currentAction = j;
        return; 
      }
    }
    return null;
  }

  async function updatedAction(ev) {
    contents.record_downloads[currentAction] = ev.detail;
    // contents.record_downloads = contents.record_downloads;
    await tick();
  }

  async function closedAction() {
    currentAction = null;
    await tick();
  }

  function deleteAction(ev) {
    const aid = ev.detail.id.toString();
    contents.record_downloads = contents.record_downloads.filter((t) => {
      return(t.id.toString() !== aid)
    })
  }

  function addDownloadRecordAction() {
    const newAction = Connector.downloadRecordAction();
    contents.record_downloads = contents.record_downloads.concat([newAction]);
    selectedAction({ id: newAction.id });
  } 


  function refreshAllActions(contents) {
    let actions = contents.record_downloads.map((rdc) => {
      if (!recordDefsHash[rdc.id] || rdc.id <= 0)
        return {
          id: -1,
          title: '. NUEVO (Aún no definido)'
        }
      else 
        return { 
          id: rdc.id,
          title: recordDefsHash[rdc.id].title
        } 
    })
    return actions;
  }


  function refreshConfig(contents) {
    /** Remake the full config using the editor contents */
    let cnf = Connector.getConfig(null); // reset to basic config
    
    let downrecords = [];
    contents.record_downloads.map((rdc) => {
      if (!recordDefsHash[rdc.id] || rdc.id <= 0)
        return; 
      let defn = RecordDef.import(recordDefsHash[rdc.id]);
      downrecords = downrecords.concat(buildConfigs(defn, settings))
    })
    cnf.download.records = downrecords;

    // console.log(JSON.stringify(cnf), null, 2);
    return cnf;
  }

  function refreshSchema(contents) {
    let schema = createDatabaseDDL(account.id);

    contents.record_downloads.map((rdc) => {
      if (!recordDefsHash[rdc.id] || rdc.id <= 0)
        return; 
      let defn = RecordDef.import(recordDefsHash[rdc.id]);
      schema = schema + createAndAlterTablesDDL(defn);
    })

    return schema;
  }


  function exportConfig() {
    /** 
     * Export all the connector Config as a text file 
     */
    let cnf = refreshConfig(contents);
    let json = JSON.stringify(cnf, null, 2);
    const fileName = slugify(connector.title || connector.uuid)+'.conf';
    createTextFileAndDownload(fileName, json)
  }


  function exportDbSchema() {
    /** 
     * Export the full DB Schema as a text file,
     * using all record_download actions to generate it
     */
    let schema = refreshSchema(contents);
    const fileName = slugify(connector.title || connector.uuid)+'.sql';
    createTextFileAndDownload(fileName, schema)
  }


  async function saveIt() {
    // alert("Guardar");
    try {
      connector.configs = [
        contents,                  // editor content is allways first row
        refreshConfig(contents), // the active Configuration
      ];

      status = IS_SAVING;
      await tick();

      let rsp = await API.connectors.put(connector.uuid, connector);
      
      status = IS_DONE;
      setTimeout(() => { 
        status = null; 
      }, 1000)
    }
    catch (err) {
      alert("Error "+err)
      status = HAS_ERRORS;
      setTimeout(() => { status = null; }, 2000)
    }
  }

  function deleteIt() {
    alert("Eliminar");
  }

</script>
